import {v$} from './helpers.js';

let defaultTarget = v$('input[type="file"]');

const handleFileInputChange = (target = defaultTarget) => {

    target = target.length > 0 ? target : [target];
    target.forEach( item => {
        let span = v$('span',item.parentNode.parentNode)[0],
            spanInitialStr = span.innerText;
        item.addEventListener('change',e => {
            let filesArr = Object.values(e.target.files),
                spanNewStr = '';
            filesArr.forEach( item => {
                spanNewStr = spanNewStr + item.name + ' ';
            })
            span.innerText = filesArr.length > 0 ? spanNewStr : spanInitialStr;  
        })
    })
 }

 export default handleFileInputChange;